import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { DashboardService } from '../dashboard.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-register-device',
  templateUrl: './register-device.component.html',
  styleUrls: ['./register-device.component.scss']
})
export class RegisterDeviceComponent implements OnInit {

  private ResponseVerifiedGetAllDevices: Subject<any> = new Subject();
  private ResponseVerifiedUpdateDevice: Subject<any> = new Subject();
  private ResponseVerifiedGetAllSubDevices: Subject<any> = new Subject();
  private ResponseVerifiedGetEpcUser: Subject<any> = new Subject();
  private ResponseVerifiedAddMultipleDevice: Subject<any> = new Subject();
  private ResponseVerifiedGetNormalUserDevice: Subject<any> = new Subject();
  private ResponseVerifiedGetAllEnergyMeter: Subject<any> = new Subject();
  public uploadFlagSpinner;
  public registrationForm: FormGroup;
  public subDeviceList: FormArray;
  multipleDevice: any = [];
  deviceInfo: any = {};
  message: any;
  devices: any;
  userList: any;
  user_Id: any;
  userId: any;
  role: any;
  roleName: string;
  userType: any;
  epcId: any;
  dev_name: any;
  demo: any;
  isEditing: any;
  normalUserDeviceList: any = [];
  deviceObject: any = {};
  deviceEditObject: any = {};
  isSelected: boolean = false;
  isNewDevice: boolean = false;
  sub_device: boolean;
  isEditDevice: boolean = true;
  is_emeter:any;
  subDevice: any;
  SubDevice_Id: any;
  SubDeviceObj: any = {};
  modelDeviceList: any = [];
  sub_device_name: any;
  subdevice_id: any;
  model_id: any;
model_name:any;
  isFirstTime: boolean = true;
  sub_device_information: any = [];
  public wmsFlag: boolean = false;
  public selectedValue: string;
  modelName: any;
  public meterType: any = [];
  public meter_slug: any;
  public  meter_type_Id: any;
  get sub_deviceFormGroup() {
    return this.registrationForm.get('sub_device_info') as FormArray;
  }
  constructor(private fb: FormBuilder, private dasbordService: DashboardService, private router: Router, private route: ActivatedRoute, private toastr: ToastrService, private modalService1: NgbModal) {

    // for edit device
    this.route.queryParams.subscribe(params => {
      if (params.id) {
        this.isEditing = params.isEditing;
        this.userId = params.id;
        this.userType = params.usertype;
        this.is_emeter = params.is_emeter;
      }
    });
    this.epcId = localStorage.id;
    this.role = localStorage.role;
    if (this.role == '1') {
      this.roleName = 'admin';
    } else if (this.role == '2') {
      this.roleName = 'epc';
    }

  }

  ngOnInit() {

    this.registrationForm = this.fb.group({
      device_id: [null, Validators.required],
      device_name: [null, Validators.compose([Validators.required])],
      device_index: [null, Validators.required],
      sub_device_info: this.fb.array([])
    });
    if (this.roleName == 'epc') {
       this.getAllSubDevice();
      this.getAllDevices();
      this.getAllMeterType();
    }
    if (this.roleName == 'epc' && this.isEditing == 'true' && this.userType == 'normaluser') {
      this.getDeviceForNormalUser(this.userId);
    }

  }
  get f() { return this.registrationForm.controls['sub_device_info']; }
  // Add sub Device
  addSub_device() {
    this.subDeviceList = this.registrationForm.controls.sub_device_info as FormArray;
    this.subDeviceList.push(this.fb.group({
      sub_device_type_id: [null, Validators.compose([Validators.required])],
      model_id: [null, Validators.compose([Validators.required])],
      meter_type_id: [null, Validators.compose([Validators.required])], // model type added  for wms energy meter
      meter_slug: [null],
      installed_capacity: [null, [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,2})?$")]],
      spec: [null, [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      name: [null, [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      sub_device_id: [null, [Validators.required, Validators.pattern("^[0-9]*$")]],
      id: [null, Validators.compose([Validators.required])],
      connected_solar_capacity: [null, [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,2})?$")]],
      subdevice_index: [null, Validators.compose([Validators.required])],
      isRemoveSubDevice: [null, Validators.compose([Validators.required])],
    }));

    if (this.subDeviceList.length > 0) {
      this.sub_device = true
    } else {
      this.sub_device = false
    }

  }



  // grt all Devices
  getAllDevices(): void {
    this.dasbordService.getAllUserDevice()
      .pipe(takeUntil(this.ResponseVerifiedGetAllDevices))
      .subscribe(
        async data => {
          if (data.status) {
            this.devices = data.resultObject;
          }
          else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  // get all Sub Device
  getAllSubDevice() {
    this.dasbordService.getAllSubDevice()
      .pipe(takeUntil(this.ResponseVerifiedGetAllSubDevices))
      .subscribe(
        async data => {
          if (this.userType == 'normaluser') {
            this.subDevice = [];
            this.subDevice.push(data.resultObject[0]);
            if(this.is_emeter==1||this.is_emeter=="1")
            {
              this.subDevice.push(data.resultObject[2]);
            }

          } else if (this.userType == 'wmsuser') {
            this.subDevice = data.resultObject;
          }
          if (data.message == 'Unauthorised or Login Time-out') {
            this.toastr.success(data.message);
            this.router.navigate(["/login"]);
          }
          else if (!data.status) {
            this.toastr.success(data.message);
          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  // on Change Subdevice
  onChangeSubDevice(value, index, controls) {
    this.SubDevice_Id = value;
    if (value == '3') {
     controls.installed_capacity.reset();
      controls.spec.reset();
      controls.connected_solar_capacity.reset();

    } else if (value == '1') {
      controls.meter_type_id.reset();
    }
  }

  getCriteria(type) {
    const select = this.subDevice.find(_ => _.sub_device_type_id == type);
    return select ? select.model_info : select;
  }

  onChangeSubDeviceModel(value) {
    this.model_id = value
  }

  removeEditSubDevice(index, device_index) {
    this.subDeviceList = this.registrationForm.controls.sub_device_info as FormArray;
    var device_id = this.registrationForm.value.device_id;
    var current_sub_device_id = this.subDeviceList.controls[index].value.id;
    var subdevice_index = this.subDeviceList.controls[index].value.subdevice_index;
    //  code for remove already device and sub sevice
    if (this.normalUserDeviceList[device_index] != undefined && this.normalUserDeviceList[device_index].device_id == device_id && this.normalUserDeviceList[device_index].isRemoveDevice == false && this.normalUserDeviceList[device_index].isNewDevice == false) {
      for (let i = 0; this.normalUserDeviceList[device_index].sub_device_info.length; i++) {
        if (this.normalUserDeviceList[device_index].sub_device_info[i].isRemoveSubDevice == false && this.normalUserDeviceList[device_index].sub_device_info[i].id == current_sub_device_id && this.normalUserDeviceList[device_index].sub_device_info[i].id != 0) {
          let tempArray = this.subDeviceList.value.filter(x => x.isRemoveSubDevice != true)
          if (tempArray.length > 1) {
            if (this.normalUserDeviceList[device_index].sub_device_info[i].id == current_sub_device_id) {
              this.normalUserDeviceList[device_index].sub_device_info[i].isRemoveSubDevice = true;
              this.subDeviceList.removeAt(index);
              break;
            }
          } else {
            if (this.normalUserDeviceList[device_index].device_id == device_id) {
              this.normalUserDeviceList[device_index].isRemoveDevice = true;
              this.subDeviceList.removeAt(index);
              this.EditCancel();
              break;
            }
          }
        } else if (this.normalUserDeviceList[device_index].sub_device_info[i].id == 0) {
          let tempArray = this.subDeviceList.value.filter(x => x.isRemoveSubDevice != true)
          if (tempArray.length > 1) {
            if (this.normalUserDeviceList[device_index].sub_device_info[i].subdevice_index == this.subDeviceList.controls[index].value.subdevice_index) {
              this.normalUserDeviceList[device_index].sub_device_info.splice(i, 1);
              this.subDeviceList.removeAt(index);
              break;
            }
          } else {
            this.normalUserDeviceList[device_index].isRemoveDevice = true;
            this.subDeviceList.removeAt(index);
            this.EditCancel();
            break;
          }
        } else if (this.subDeviceList.controls[index].value.id == null) {
          let tempArray = this.subDeviceList.value.filter(x => x.isRemoveSubDevice != true)
          if (tempArray.length > 1) {
            this.subDeviceList.removeAt(index);
            break;
          } else {
            this.subDeviceList.removeAt(index);
            this.normalUserDeviceList[device_index].isRemoveDevice = true
            this.EditCancel();
            break;
          }
        }
      }
    } else if (this.normalUserDeviceList[device_index] != undefined && device_index != null && this.normalUserDeviceList[device_index].isNewDevice == true) {
      //  code for remove new device and sub sevice
      let tempArray = this.subDeviceList.value.filter(x => x.isRemoveSubDevice != true)
      if (tempArray.length > 1) {
        for (let j = 0; j < this.normalUserDeviceList[device_index].sub_device_info.length; j++) {
          if (this.normalUserDeviceList[device_index].sub_device_info[j].id == 0 && this.normalUserDeviceList[device_index].sub_device_info[j].subdevice_index == subdevice_index) {
            this.normalUserDeviceList[device_index].sub_device_info.splice(j, 1);
            this.subDeviceList.removeAt(index);
            break;
          } else if (this.subDeviceList.controls[index].value.id == null) {
            this.subDeviceList.removeAt(index);
            break;
          }
        }
      } else {
        for (let j = 0; j < this.normalUserDeviceList[device_index].sub_device_info.length; j++) {
          if (this.normalUserDeviceList[device_index].sub_device_info[j].id == 0 && this.normalUserDeviceList[device_index].sub_device_info[j].subdevice_index == subdevice_index) {
            this.normalUserDeviceList[device_index].sub_device_info.splice(j, 1);
            this.normalUserDeviceList.splice(device_index, 1);
            this.subDeviceList.removeAt(index);
            this.EditCancel();
            break;
          } else if (this.subDeviceList.controls[index].value.id == null) {
            this.normalUserDeviceList.splice(device_index, 1);
            this.subDeviceList.removeAt(index);
            this.EditCancel();
            break;
          }
        }
      }
    }
    else {
      // let tempArray = this.subDeviceList.value.filter(x => x.isRemoveSubDevice != true)
      if (this.subDeviceList.length > 1) {
        this.subDeviceList.removeAt(index);
      } else {
        this.subDeviceList.removeAt(index);
        this.EditCancel();
      }
    }
  }


  submitEdit() {
    this.sub_device_information = this.registrationForm.value.sub_device_info;
    // removed model id, connected someter_sluglar capacity, installed capacity, meter type as validations added on form
    if (this.sub_device_information.find(x => x.sub_device_type_id == null || x.name == null || x.sub_device_id == null)) {
      this.toastr.info("Please fill the all Feild");
    }
    else {
      if (this.isNewDevice == false) {
        //Update already Exist Device with new or old sub device
        var device_info = this.registrationForm.value
        for (let i = 0; i < this.normalUserDeviceList.length; i++) {
          if (this.normalUserDeviceList[i].device_id == device_info.device_id) {
            for (let j = 0; j < this.registrationForm.value.sub_device_info.length; j++) {
              if (this.registrationForm.value.sub_device_info[j].id != null) {
                for (let e = 0; e < this.normalUserDeviceList[i].sub_device_info.length; e++) {
                  if (this.normalUserDeviceList[i].sub_device_info[e].id != 0 && this.normalUserDeviceList[i].sub_device_info[e].id == this.registrationForm.value.sub_device_info[j].id) {

                    this.normalUserDeviceList[i].sub_device_info[e].installed_capacity = this.registrationForm.value.sub_device_info[j].installed_capacity;
                    this.normalUserDeviceList[i].sub_device_info[e].name = this.registrationForm.value.sub_device_info[j].name;
                    this.normalUserDeviceList[i].sub_device_info[e].spec = this.registrationForm.value.sub_device_info[j].spec;
                    this.normalUserDeviceList[i].sub_device_info[e].sub_device_type_id = this.registrationForm.value.sub_device_info[j].sub_device_type_id;
                    this.normalUserDeviceList[i].sub_device_info[e].model_id = this.registrationForm.value.sub_device_info[j].model_id;
                    this.normalUserDeviceList[i].sub_device_info[e].meter_type_id = this.registrationForm.value.sub_device_info[j].meter_type_id;
                    this.normalUserDeviceList[i].sub_device_info[e].sub_device_id = this.registrationForm.value.sub_device_info[j].sub_device_id;
                    this.normalUserDeviceList[i].sub_device_info[e].connected_solar_capacity = this.registrationForm.value.sub_device_info[j].connected_solar_capacity;
                    // push Inverter Name
                    for (var y = 0; y < this.subDevice.length; y++) {
                      if (this.subDevice[y].sub_device_type_id == this.registrationForm.value.sub_device_info[j].sub_device_type_id) {
                        this.normalUserDeviceList[i].sub_device_info[e].sub_device_name = this.subDevice.find(x => x.sub_device_type_id == this.registrationForm.value.sub_device_info[j].sub_device_type_id).name;
                      }
                    }
                    // push meter_slug
                    for (var s = 0; s < this.meterType.length; s++) {
                      if (this.meterType[s].id == this.registrationForm.value.sub_device_info[j].meter_type_id) {
                        this.normalUserDeviceList[i].sub_device_info[e].name = this.meterType.find(x => x.id == this.registrationForm.value.sub_device_info[j].meter_type_id).name;
                      }
                    }
                    // push meter type id
                    for (var q = 0; q < this.meterType.length; q++) {
                      if (this.meterType[q].id == this.registrationForm.value.sub_device_info[j].meter_type_id) {
                        this.normalUserDeviceList[i].sub_device_info[e].meter_slug = this.meterType.find(x => x.id == this.registrationForm.value.sub_device_info[j].meter_type_id).meter_slug;
                      }
                    }
                    // push model name
                    for (var z = 0; z < this.subDevice.length; z++) {
                      if (this.subDevice[z].sub_device_type_id == this.registrationForm.value.sub_device_info[j].sub_device_type_id) {
                        this.normalUserDeviceList[i].sub_device_info[e].model_name = this.subDevice[z].model_info.find(x => x.model_id == this.registrationForm.value.sub_device_info[j].model_id).model_name;
                      }
                    }
                    // add for meter type ??
                  } else if (this.normalUserDeviceList[i].sub_device_info[e].id == 0 && this.normalUserDeviceList[i].sub_device_info[e].subdevice_index == this.registrationForm.value.sub_device_info[j].subdevice_index) {
                    this.normalUserDeviceList[i].sub_device_info[e].installed_capacity = this.registrationForm.value.sub_device_info[j].installed_capacity;
                    this.normalUserDeviceList[i].sub_device_info[e].name = this.registrationForm.value.sub_device_info[j].name;
                    this.normalUserDeviceList[i].sub_device_info[e].spec = this.registrationForm.value.sub_device_info[j].spec;
                    this.normalUserDeviceList[i].sub_device_info[e].sub_device_type_id = this.registrationForm.value.sub_device_info[j].sub_device_type_id;
                    this.normalUserDeviceList[i].sub_device_info[e].model_id = this.registrationForm.value.sub_device_info[j].model_id;
                    this.normalUserDeviceList[i].sub_device_info[e].meter_type_id = this.registrationForm.value.sub_device_info[j].meter_type_id;
                    this.normalUserDeviceList[i].sub_device_info[e].meter_slug = this.registrationForm.value.sub_device_info[j].meter_slug;
                    this.normalUserDeviceList[i].sub_device_info[e].sub_device_id = this.registrationForm.value.sub_device_info[j].sub_device_id;
                    this.normalUserDeviceList[i].sub_device_info[e].connected_solar_capacity = this.registrationForm.value.sub_device_info[j].connected_solar_capacity;
                    // push Inverter Name
                    for (var y = 0; y < this.subDevice.length; y++) {
                      if (this.subDevice[y].sub_device_type_id == this.registrationForm.value.sub_device_info[j].sub_device_type_id) {
                        this.normalUserDeviceList[i].sub_device_info[e].sub_device_name = this.subDevice.find(x => x.sub_device_type_id == this.registrationForm.value.sub_device_info[j].sub_device_type_id).name;
                      }
                    }
                    // push model name
                    for (var z = 0; z < this.subDevice.length; z++) {
                      if (this.subDevice[z].sub_device_type_id == this.registrationForm.value.sub_device_info[j].sub_device_type_id) {
                        this.normalUserDeviceList[i].sub_device_info[e].model_name = this.subDevice[z].model_info.find(x => x.model_id == this.registrationForm.value.sub_device_info[j].model_id).model_name;
                      }
                    }
                    // push meter slug
                    for (var s = 0; s < this.meterType.length; s++) {
                      if (this.meterType[s].id == this.registrationForm.value.sub_device_info[j].meter_type_id) {
                        this.normalUserDeviceList[i].sub_device_info[e].meter_slug = this.meterType.find(x => x.id == this.registrationForm.value.sub_device_info[j].meter_type_id).meter_slug;
                      }
                    }
                    // push meter name
                    for (var q = 0; q < this.meterType.length; q++) {
                      if (this.meterType[q].id == this.registrationForm.value.sub_device_info[j].meter_type_id) {
                        this.normalUserDeviceList[i].sub_device_info[e].name = this.meterType.find(x => x.id == this.registrationForm.value.sub_device_info[j].meter_type_id).name;
                      }
                    }
                  }
                }
              } else {  //Push new subdevice into device
                this.normalUserDeviceList[i].sub_device_info.push(this.registrationForm.value.sub_device_info[j]);
                let curIndex = this.normalUserDeviceList[i].sub_device_info.length - 1;
                this.normalUserDeviceList[i].sub_device_info[curIndex].id = 0;
                this.normalUserDeviceList[i].sub_device_info[curIndex].subdevice_index = j;
                this.normalUserDeviceList[i].sub_device_info[curIndex].isRemoveSubDevice = false;
                // push Inverter Name
                for (var y = 0; y < this.subDevice.length; y++) {
                  if (this.subDevice[y].sub_device_type_id == this.registrationForm.value.sub_device_info[j].sub_device_type_id) {
                    this.normalUserDeviceList[i].sub_device_info[curIndex].sub_device_name = this.subDevice.find(x => x.sub_device_type_id == this.registrationForm.value.sub_device_info[j].sub_device_type_id).name;
                  }
                }
                // push model name
                for (var z = 0; z < this.subDevice.length; z++) {
                  if (this.subDevice[z].sub_device_type_id == this.registrationForm.value.sub_device_info[j].sub_device_type_id) {
                    this.normalUserDeviceList[i].sub_device_info[curIndex].model_name = this.subDevice[z].model_info.find(x => x.model_id == this.registrationForm.value.sub_device_info[j].model_id).model_name;
                  }
                }
                // push meter slug
                for (var s = 0; s < this.meterType.length; s++) {
                  if (this.meterType[s].id == this.registrationForm.value.sub_device_info[j].meter_type_id) {
                    this.normalUserDeviceList[i].sub_device_info[curIndex].meter_slug = this.meterType.find(x => x.id == this.registrationForm.value.sub_device_info[j].meter_type_id).meter_slug;
                  }
                }
                // push meter name
                for (var q = 0; q < this.meterType.length; q++) {
                  if (this.meterType[q].id == this.registrationForm.value.sub_device_info[j].meter_type_id) {
                    this.normalUserDeviceList[i].sub_device_info[curIndex].name = this.meterType.find(x => x.id == this.registrationForm.value.sub_device_info[j].meter_type_id).name;
                  }
                }

              }
            }
          }
        }
        length = this.subDeviceList.length
        for (let i = length - 1; i >= 0; i--) {
          this.subDeviceList.removeAt(i)
        }
        this.isSelected = false;
        this.isNewDevice = false;
        this.registrationForm.reset();
        // end allready exist divice
      } else { //Push new device
        for (let index = 0; index < this.devices.length; index++) {
          const device_id = this.devices[index].device_id;
          if (device_id == this.registrationForm.value.device_id) {
            this.demo = this.devices[index].dev_name;
            this.normalUserDeviceList.push(this.registrationForm.value);
            this.normalUserDeviceList.find(x => x.device_id == this.registrationForm.value.device_id).dev_name = this.demo;
            this.normalUserDeviceList.find(x => x.device_id == this.registrationForm.value.device_id).isNewDevice = this.isNewDevice;
            if (this.isNewDevice == true) {
              this.normalUserDeviceList.find(x => x.device_id == this.registrationForm.value.device_id).isRemoveDevice = false;
            }
            for (var i = 0; i < this.normalUserDeviceList.length; i++) {
              if (this.normalUserDeviceList[i].device_id == this.registrationForm.value.device_id) {
                for (var j = 0; j < this.normalUserDeviceList[i].sub_device_info.length; j++) {
                  if (this.normalUserDeviceList[i].sub_device_info[j].id == null) {
                    this.normalUserDeviceList[i].sub_device_info[j].id = 0;
                    this.normalUserDeviceList[i].sub_device_info[j].isRemoveSubDevice = false;
                    this.normalUserDeviceList[i].sub_device_info[j].subdevice_index = j;
                    // push Inverter Name
                    for (var y = 0; y < this.subDevice.length; y++) {
                      if (this.subDevice[y].sub_device_type_id == this.registrationForm.value.sub_device_info[j].sub_device_type_id) {
                        this.normalUserDeviceList[i].sub_device_info[j].sub_device_name = this.subDevice.find(x => x.sub_device_type_id == this.registrationForm.value.sub_device_info[j].sub_device_type_id).name;
                      }
                    }
                    // push meter slug
                    for (var s = 0; s < this.meterType.length; s++) {
                      if (this.meterType[s].id == this.registrationForm.value.sub_device_info[j].meter_type_id) {
                        this.normalUserDeviceList[i].sub_device_info[j].meter_slug = this.meterType.find(x => x.id == this.registrationForm.value.sub_device_info[j].meter_type_id).meter_slug;
                      }
                    }
                    for (var q = 0; q < this.meterType.length; q++) {
                      if (this.meterType[q].id == this.registrationForm.value.sub_device_info[j].meter_type_id) {
                        this.normalUserDeviceList[i].sub_device_info[j].name = this.meterType.find(x => x.id == this.registrationForm.value.sub_device_info[j].meter_type_id).name;
                      }
                    }
                    //  push model Name
                    for (var z = 0; z < this.subDevice.length; z++) {
                      if (this.subDevice[z].sub_device_type_id == this.registrationForm.value.sub_device_info[j].sub_device_type_id) {
                        this.normalUserDeviceList[i].sub_device_info[j].model_name = this.subDevice[z].model_info.find(x => x.model_id == this.registrationForm.value.sub_device_info[j].model_id).model_name;
                      }
                    }
                    // code to push energy meter required
                  }
                }
              }
            }
          }
        }

        // remove FormArray Actomaticaly after submit one device and sub devise
        length = this.subDeviceList.length
        for (let i = length - 1; i >= 0; i--) {
          this.subDeviceList.removeAt(i)
        }
        // this.registrationForm.reset();
        this.isNewDevice = false;
        this.isSelected = false;
        this.registrationForm.reset();
      }
      this.sub_device = false
    }
    this.isEditDevice = true;
  }

  getContactsFormGroup(index): FormGroup {
    const formGroup = this.subDeviceList.controls[index] as FormGroup;
    return formGroup;
  }
  // on change method isedit form
  onEditChange(value) {
    this.isNewDevice = true;
    var d = this.normalUserDeviceList.find(x => x.device_id == this.registrationForm.value.device_id);
    this.subDeviceList = this.registrationForm.controls.sub_device_info as FormArray;
    if (this.subDeviceList.length > 0 && this.normalUserDeviceList.find(x => x.device_id == value)) {
      for (let i = length - 1; i >= 0; i--) {
        this.subDeviceList.removeAt(i)
      }
      this.toastr.success("Device is Allready Selected Please Select Other Device!!!");
    }else if(this.subDeviceList.length > 0 && value ==""){
      for (let i = this.subDeviceList.length - 1; i >= 0; i--) {
        this.subDeviceList.removeAt(i)
      }
    }
    else if (d == undefined && value != d && value !="") {
      if (this.subDeviceList.length == 0) {
        this.addSub_device();
      }
    }
    else {
      this.toastr.success("Device is Allready Selected !!!");
      return false;
    }
  }
  onChangeUser(value) {
    this.user_Id = value;
  }


  removeDevice(index) {
    this.multipleDevice.splice(index, 1)
  }


  //get devices for normal_user by user id
  getDeviceForNormalUser(userId) {
    this.deviceObject = {
      user_id: userId,
    }
    this.dasbordService.getNormalUserDevicesById(this.deviceObject)
      .pipe(takeUntil(this.ResponseVerifiedGetNormalUserDevice))
      .subscribe(
        async data => {
          if (data.status) {
            this.normalUserDeviceList = data.device_info;
          }
          else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }


  // remove device for edit table action
  removeEditDevice(index, device_id) {
    var dev = this.normalUserDeviceList.find(x => x.device_id == device_id);
    if (this.normalUserDeviceList.find(x => x.device_id == device_id).isNewDevice == false) {
      this.normalUserDeviceList.find(x => x.device_id == device_id).isRemoveDevice = true;
    } else {
      this.normalUserDeviceList.splice(index, 1);
    }
    this.registrationForm.reset();
    this.EditCancel();
    this.sub_device = false;
  }
  // edit device method
  EditDevice(device_id, index) {

    this.subDeviceList = this.registrationForm.controls.sub_device_info as FormArray;
    if (this.isEditDevice == true && this.subDeviceList.length == 0) {
      this.isSelected = true;
      var dev = this.normalUserDeviceList.find(x => x.device_id == device_id).dev_name;
      var subDevLength = this.normalUserDeviceList.find(x => x.device_id == device_id).sub_device_info;
      this.registrationForm.get('device_name').setValue(dev);
      this.registrationForm.get('device_id').setValue(device_id);
      this.registrationForm.get('device_index').setValue(index);
      for (var i = 0; i < subDevLength.length; i++) {
      this.addSub_device();
      }
      this.registrationForm.patchValue({
        sub_device_info: subDevLength
      })
      this.isEditDevice = false
    } else {
      this.toastr.error("Please Click Save Device or Cancel Device");
    }
  }


  EditCancel() {
    this.subDeviceList = this.registrationForm.controls.sub_device_info as FormArray;
    length = this.subDeviceList.length;
    if (length > 0) {
      for (let i = length - 1; i >= 0; i--) {
        this.subDeviceList.removeAt(i)
      }
    }
    this.isSelected = false;
    this.isNewDevice = false;
    this.isEditDevice = true;
    this.sub_device = false;
    this.registrationForm.reset();
  }

  updateDeviceById() {
    this.deviceEditObject = {
      epc_id: this.epcId,
      user_id: this.userId,
      device_info: this.normalUserDeviceList
    }

   this.dasbordService.updateDeviceById(this.deviceEditObject)
      .pipe(takeUntil(this.ResponseVerifiedUpdateDevice))
      .subscribe(
        async data => {
          this.normalUserDeviceList = data.device_info;
          if (data.status === true || data.status === 'true') {
            this.toastr.success("Device Updated Succesully!!!")
            if (this.userType == "wmsuser") {
              this.router.navigate(['/inject-solar/wms-users']);
            } else if (this.userType == "normaluser") {
              this.router.navigate(['/inject-solar/register-epc-users/normal-users']);
            }
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  // disable sevice dropdown
  checkArray(id){
    let flag = this.normalUserDeviceList.find(x => x.device_id === id);
    return flag;
  }


  //get all meter type
  getAllMeterType() {

    this.dasbordService.getAllMeterTypeByEpc()
      .pipe(takeUntil(this.ResponseVerifiedGetAllEnergyMeter))
      .subscribe(
        async data => {
          this.meterType  = data.resultObject;
            if (data.message == 'Unauthorised or Login Time-out') {
            this.toastr.success(data.message);
            this.router.navigate(["/login"]);
          }
          else if (!data.status) {
            this.toastr.success(data.message);
          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  onChangeMeterType(value) {
    this.meter_type_Id = value
  }
  filterItemsOfType(type) {
    return type.filter(x => x.isRemoveSubDevice == false);
  }
  ngOnDestroy() {
    this.ResponseVerifiedGetAllDevices.next();
    this.ResponseVerifiedGetAllDevices.complete();

    this.ResponseVerifiedUpdateDevice.next();
    this.ResponseVerifiedUpdateDevice.complete();

    this.ResponseVerifiedGetAllSubDevices.next();
    this.ResponseVerifiedGetAllSubDevices.complete();

    this.ResponseVerifiedGetEpcUser.next();
    this.ResponseVerifiedGetEpcUser.complete();

    this.ResponseVerifiedAddMultipleDevice.next();
    this.ResponseVerifiedAddMultipleDevice.complete();

    this.ResponseVerifiedGetNormalUserDevice.next();
    this.ResponseVerifiedGetNormalUserDevice.complete();


  this.ResponseVerifiedGetAllEnergyMeter.next();
  this.ResponseVerifiedGetAllEnergyMeter.complete();
  }
}

